// Libraries
import clsx from "clsx";
import { Grid, Stack, Typography } from "@mui/material";

// Components
import InputSection from "@/Settings/components/PayrollMapping/InputSection/InputSection";

// Types
import { IPayrollProviderPayItemOption, ISystemSettingsPayItem } from "@/Settings/types/PayrollMapping/api";
import { TSelectedValuesInput } from "@Layouts/types/HierarchicalSelector";

// Layouts
import SimpleIconButton from "@/Layouts/components/Buttons/SimpleIconButton";

// Icons
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import { AddCircleRounded } from "@mui/icons-material";
// Helpers
import { isLastInputFulfilled } from "@/Settings/helpers/PayrollMapping";
type TPayItemsRowProps = {
	payItemIndex: number;
	name: string;
	value: ISystemSettingsPayItem[];
	options: IPayrollProviderPayItemOption[];
	disabled: boolean;
	onAddNewInput: (payItemIndex: number) => void;
	onRemoveInput: (payItemIndex: number, childIndex: number) => void;
	onChangeInput: (payItemIndex: number, childIndex: number, value?: TSelectedValuesInput) => void;
};

export default function PayItemsRow(props: Readonly<TPayItemsRowProps>) {
	const { payItemIndex, name, value: inputs, options, disabled, onAddNewInput, onRemoveInput, onChangeInput } = props;

	const disabledAddButton = !options?.length || disabled || !isLastInputFulfilled(inputs);
	return (
		<Grid container direction="row" alignItems="center">
			<Grid item xs={2.5}>
				<Typography className="!font-sans !text-[14.5px] !font-normal !text-default">{name}</Typography>
			</Grid>
			<Grid item container direction="row" xs={9.5} alignItems="center">
				{inputs?.map((value, index, array) => {
					const { displayId, name, companyId, componentId } = value;
					const inputValues = [
						{ label: displayId, value: displayId, extra: companyId },
						{ label: name, value: name, extra: componentId },
					];
					const ownError = !displayId || !name;
					const anyErrorInSiblings = array.some((input) => !input.displayId || !input.name);
					return (
						<InputSection
							key={`${payItemIndex}-input-${value.componentId}`}
							inputValues={inputValues}
							onRemoveInput={() => onRemoveInput(payItemIndex, index)}
							options={options.map((opt) => ({
								displayId: opt.displayId,
								companyId: opt.companyId,
								items: opt.payItems,
							}))}
							mapFunction={(item) => ({ name: item.name, id: item.componentId })}
							disabled={disabled || (!ownError && anyErrorInSiblings)}
							index={{
								itemIndex: payItemIndex,
								inputIndex: index,
							}}
							onChange={onChangeInput}
						/>
					);
				})}
				{/* Add button */}
				<Stack className={clsx({ "!ml-[-8px]": (inputs?.length ?? 0) % 4 === 0 })}>
					<SimpleIconButton
						className={clsx({ "!text-primary": !disabledAddButton, "!text-disabled": disabledAddButton })}
						icon={<AddCircleOutlineRoundedIcon fontSize="medium" />}
						iconHover={<AddCircleRounded fontSize="medium" />}
						disabled={disabledAddButton}
						onClick={() => onAddNewInput(payItemIndex)}
					/>
				</Stack>
			</Grid>
		</Grid>
	);
}
